import { forms } from './modules/forms.js';
import { modalControls } from './modules/modal-controls.js';

forms();
modalControls();

